import { render, staticRenderFns } from "./ForwarderList.vue?vue&type=template&id=162d8c4b&scoped=true"
import script from "./ForwarderList.vue?vue&type=script&lang=js"
export * from "./ForwarderList.vue?vue&type=script&lang=js"
import style0 from "./ForwarderList.vue?vue&type=style&index=0&id=162d8c4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162d8c4b",
  null
  
)

export default component.exports